import { Matrix, ismatrix } from 'mdatools/arrays';
import { ssq, variance } from 'mdatools/stat';
import { pca_getreslength } from './pcvpca.js';

export function get_regstat(res) {

   if (!res.Yref || !ismatrix(res.Yref)) return null;

   const Y = res.Yref;
   const ncomp = res.ncomp;
   const nresp = Y.ncols;
   const nrows = Y.nrows;

   // get predicted y-values
   const yp_offset = pca_getreslength(nrows, ncomp);
   const yp_length = ncomp * nresp * nrows;
   const Yp = res.v.subarray(yp_offset, yp_offset + yp_length);

   // prepare matrices for RMSE and R2
   const RMSE = Matrix.zeros(nresp, ncomp);
   const R2 = Matrix.zeros(nresp, ncomp);

   // compute total variance for each response
   const ssy = new Float64Array(nresp);
   for (let iy = 0; iy < nresp; iy++) {
      const y = Y.getcolref(iy + 1);
      ssy[iy] = variance(y) * (nrows - 1);
   }

   for (let a = 1; a <= ncomp; a++) {
      const Ypa = new Matrix(Yp.subarray((a - 1) * nrows * nresp, a * nrows * nresp), nrows, nresp);
      const E = Y.subtract(Ypa);
      const rmsea = RMSE.getcolref(a);
      const r2a = R2.getcolref(a);

      for (let iy = 0; iy < nresp; iy++) {
         const e = E.getcolref(iy + 1);
         const sse = ssq(e);
         r2a[iy] = 1 - sse / ssy[iy];
         rmsea[iy] = Math.sqrt(sse / nrows);
      }
   }

   return {RMSE: RMSE.t(), R2: R2.t()};
}
